import type { ActionDefinition } from '@gzl10/nexus-sdk'

/**
 * Row action — installs a plugin via ctx.core.plugins.install()
 */
export const installPluginAction: ActionDefinition = {
  key: 'install',
  scope: 'row',
  group: { en: 'Plugin Management', es: 'Gestión de plugins' },
  label: { en: 'Install', es: 'Instalar' },
  icon: 'mdi:download',
  output: {},

  input: {
    version: {
      label: { en: 'Version', es: 'Versión' },
      input: 'text',
      hint: { en: 'Optional (defaults to latest)', es: 'Opcional (por defecto latest)' }
    }
  },

  confirm: {
    type: 'simple',
    message: { en: 'This will install the plugin and restart the server.', es: 'Esto instalará el plugin y reiniciará el servidor.' },
    severity: 'warning'
  },

  select: ['name'],

  handler: async (ctx, input) => {
    const { version, _record } = input as { version?: string; _record: { name: string } }
    const name = _record.name

    ctx.core.logger.info({ name, version }, 'Installing plugin')

    ctx.events.notify('audit.log', {
      source: 'core:plugins',
      action: 'plugin_installed',
      resourceType: 'plugin',
      resourceId: name
    })

    try {
      await ctx.core.plugins.install(name, { version: version || undefined })
    } catch (error) {
      ctx.core.logger.error({ error, name }, 'Failed to install plugin')
      throw new ctx.core.errors.AppError(`Failed to install plugin: ${(error as Error).message}`, 500)
    }

    ctx.core.logger.info({ name }, 'Plugin installed, scheduling restart')

    setTimeout(() => {
      process.exit(0)
    }, 500)

    return {
      success: true,
      message: `Plugin ${name} installed. Server restarting...`
    }
  }
}
